import React from 'react';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import CustomHeader from '../../../../Components/AgGrid/CustomHeader';

export const getColumnDefs1 = (props) => [
  {
    field: 'no',
    headerName: 'NO',
    maxWidth: 80,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
    cellClass: 'delete-action-cell',
    cellRenderer: (params) => (
      <GridCheckBox
        params={params}
        DeleteNewRow={props.DeleteNewRow1}
        RestoreRow={props.RestoreRow1}
        gridRef={props.gridRef1}
        rowData={props.rowData1}
        selectedRowNosRef={props.selectedRowNosRef1}
        lastCheckedIndexRef={props.lastCheckedIndexRef1}
        handleRowSelection={props.handleRowSelection1}
      />
    ),
  },
  {
    field: 'menuId',
    headerName: '메뉴ID',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 120,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'menuNm',
    headerName: '메뉴명',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 200,
    flex: 1,
    editable: true,
  },
  {
    field: 'menuTypeNm',
    headerName: '메뉴타입',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 100,
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: (props.codeList || [])
        .filter((f) => (f.groupCd ?? f.GroupCd) === 'MENU_TYPE')
        .map((item) => item.codeNm ?? item.CodeNm),
    },
    editable: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    onCellValueChanged: (params) => {
      if (params.newValue === '대분류') {
        params.data.menuUp = params.data.menuId;
      } else {
        params.data.menuUp = null;
      }
      params.api.refreshCells({ rowNodes: [params.node], force: true });
    },
  },
  {
    field: 'menuUp',
    headerName: '상위메뉴',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 100,
    editable: (params) => params.data.menuTypeNm === '중분류',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: (params) => {
      if (params.data.menuTypeNm === '중분류') {
        return { values: (props.menuUpList || []).map((item) => item.menuId) };
      }
      return { values: [] };
    },
    valueSetter: (params) => {
      if (params.data.menuTypeNm === '대분류') {
        params.data.menuUp = params.data.menuId;
        return true;
      }
      params.data.menuUp = params.newValue;
      return true;
    },
    cellStyle: (params) =>
      params.data.menuTypeNm === '대분류'
        ? { backgroundColor: '#f0f0f0', color: '#888' }
        : {},
  },
  {
    field: 'screenTypeNm',
    headerName: '메뉴스크린',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 120,
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: (props.codeList || [])
        .filter((f) => (f.groupCd ?? f.GroupCd) === 'SCREEN_TYPE')
        .map((item) => item.codeNm ?? item.CodeNm),
    },
    editable: true,
  },
  {
    field: 'seq',
    headerName: '순번',
    maxWidth: 100,
    cellStyle: { textAlign: 'right' },
    editable: true,
  },
];

export const getColumnDefs2 = (props) => [
  {
    field: 'no',
    headerName: 'NO',
    maxWidth: 80,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
    cellClass: 'delete-action-cell',
    cellRenderer: (params) => (
      <GridCheckBox
        params={params}
        DeleteNewRow={props.DeleteNewRow2}
        RestoreRow={props.RestoreRow2}
        gridRef={props.gridRef2}
        rowData={props.rowData2}
        selectedRowNosRef={props.selectedRowNosRef2}
        lastCheckedIndexRef={props.lastCheckedIndexRef2}
        handleRowSelection={props.handleRowSelection2}
      />
    ),
  },
  {
    field: 'proId',
    headerName: '프로그램ID',
    headerComponent: CustomHeader,
    headerComponentParams: { required: true },
    minWidth: 120,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'proContent',
    headerName: '프로그램 설명',
    minWidth: 300,
    flex: 1,
    editable: true,
  },
];
